import type { DefaultResponseBody, ListResponseBody, Song, SongDetail } from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreSongsApi(client: ApiClient) {
  return {
    list: (
      params: {
        page?: number;
        limit?: number;
        categoryId?: number;
        artistId?: number;
        sort?: "newest" | "popular" | "likes" | "trending";
        search?: string;
      } = {},
      signal?: AbortSignal,
    ) =>
      client
        .request<ListResponseBody<Song>>("/songs", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    /** Suggested songs for a detail page — same artist, then category, then newest; never empty while anything else is published. */
    related: (id: number | string, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Song>>(`/songs/${id}/related`, { query: { limit: 12 }, signal })
        .then((res) => res.data?.list ?? []),

    detail: (id: number | string, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<SongDetail>>(`/songs/${id}`, { signal })
        .then((res) => res.data as SongDetail),

    /** Signed-in only: a single-file URL capped to the plan's download quality. Throws `plan.download_blocked` when the plan forbids downloads. */
    download: (id: number | string) =>
      client
        .request<DefaultResponseBody<{ url: string; maxKbps?: number }>>(`/songs/${id}/download`)
        .then((res) => res.data),

    /** `GET /songs/:code/stream` — the public key is the short code. */
    streamUrl: (id: number | string) => `${client.baseUrl}/songs/${id}/stream`,
  };
}
